export default "__VITE_ASSET__Dekp43$M__"